<template>
  <div :class="containerClassName">
    <input
      type="text"
      autocomplete="off"
      :id="id"
      :name="name"
      v-model="model"
      :class="inputClasses"
      :disabled="disabled"
      :readonly="readonly"
      :placeholder="placeholder"
      :maxlength="maxlength"
      @paste="onPaste"
      @blur="onBlur"
    >
    <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#button-glyph-pencil"></use></svg></span>
  </div>
</template>

<script>
export default {
  name: 'TheDecimalInput',
  inject: [
    '$validator'
  ],
  props: {
    id: {
      type: String,
      default: function () {
        return 'decimal-input-id-' + this._uid
      }
    },
    name: {
      type: String,
      default: null
    },
    value: {
      default: ''
    },
    containerClassName: {
      type: String,
      default: 'input-container minimal'
    },
    placeholder: {
      type: String,
      default: ''
    },
    maxlength: {
      type: String,
      default: null
    },
    disabled: {
      type: [Boolean, Number],
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputClasses: function () {
      let cls = []

      // Add the main class name
      cls.push(this.className)

      // Add disabled
      if (this.disabled) {
        cls.push('disabled')
      }

      // Add readonly
      if (this.readonly) {
        cls.push('readonly')
      }

      return cls
    },
    model: {
      get () {
        const str = this.value ? this.value.toString() : ''

        return str.replace(/,+/, '.').replace(/\s+/g, '')

        // const tmpValue = this.value ? this.value.toString() : ''
        // const value = tmpValue.replace(/,+/, '.').replace(/\s+/g, '').split('.')

        // if (value[0] === '-') {
        //   console.log('IS MINUS')
        //   value[0] = '-0'
        // }

        // const decimal = value[1] && typeof value[1] !== 'undefined' ? '.' + value[1] : ''

        // console.log(value, value[0], decimal, Number(value[0]).toLocaleString('nb-NO'))

        // return Number(value[0]).toLocaleString('nb-NO') + decimal
      },
      set (newValue) {
        var vm = this
        setTimeout(function () {
          vm.$emit('input', newValue.replace(/,+/, '.').replace(/\s+/g, ''))
        })
      }
    }
  },
  methods: {
    onPaste: function (e) {
      const vm = this

      setTimeout(function () {
        e.preventDefault()

        const value = e.target.value.replace(/,+/, '.').replace(/\s+/g, '').split('.')
        const decimal = typeof value[1] !== 'undefined' ? '.' + value[1] : ''

        e.target.value = Number(value[0]).toLocaleString('nb-NO') + decimal

        vm.$emit('input', e.target.value)
      })
    },
    onBlur: function (e) {
      this.$emit('blur')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Inputs/TheDecimalInputTable.vue